import { render, staticRenderFns } from "./WaitingForPrintWarrantyCard.vue?vue&type=template&id=6d4fca14"
import script from "./WaitingForPrintWarrantyCard.vue?vue&type=script&lang=js"
export * from "./WaitingForPrintWarrantyCard.vue?vue&type=script&lang=js"
import style0 from "./WaitingForPrintWarrantyCard.vue?vue&type=style&index=0&id=6d4fca14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports